var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "blok-button",
      style: _vm.wrapStyles,
    },
    [
      _c(
        "a",
        {
          class: _vm.linkClasses,
          attrs: { href: _vm.blok.link, "aria-label": _vm.blok.text },
          on: { click: _vm.trackButtonClick },
        },
        [_vm._v("\n    " + _vm._s(_vm.blok.text) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }